export const iconFontAwesomeSecurityIdCard = (
	<i className="fa-solid fa-id-card"></i>
);
